import { render, staticRenderFns } from "./WeeklyTasks.vue?vue&type=template&id=35c18bb0&"
import script from "./WeeklyTasks.vue?vue&type=script&lang=js&"
export * from "./WeeklyTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports